import { render, staticRenderFns } from "./POSkartica.vue?vue&type=template&id=76d3c606&scoped=true"
import script from "./POSkartica.vue?vue&type=script&lang=js"
export * from "./POSkartica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d3c606",
  null
  
)

export default component.exports